<template>
    <v-alert
        outlined
        :color="alert_color"
        class="d-inline-block mb-0"
    >
        <v-subheader
            class="pl-0 mt-2"
            style="height: auto;"
        >
            <strong>
                {{ header_text }}
            </strong>
        </v-subheader>

        <div
            v-if="subheader_text"
            class="pl-0 pr-2 pb-1 text-body-2"
        >
            {{ subheader_text }}
        </div>

        <v-list
            color="transparent"
            style="background: transparent;"
            class="d-flex flex-column gap-2"
            dense
        >
            <v-list-item
                v-for="(item, index) in reasons"
                :key="index"
            >
                <v-list-item-icon class="my-0 mr-1">
                    <v-icon
                        :color="icon_color"
                        aria-hidden="true"
                        small
                    >
                        mdi-alert-circle-outline
                    </v-icon>
                </v-list-item-icon>

                <v-list-item-content class="pa-0">
                    <v-list-item-subtitle
                        :class="list_text_class"
                        style="font-size: 14px;"
                    >
                        {{ item.text }}

                        <a
                            v-if="item.help_text"
                            class="secondary--text"
                            style="text-decoration: underline;"
                            @click="showHelpAlert(item)"
                        >
                            help
                        </a>

                        <v-btn
                            v-else-if="item.target"
                            :color="action_button_color"
                            class="ml-2"
                            outlined
                            x-small
                            @click="onFixItem(item)"
                        >
                            Fix It
                        </v-btn>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-alert>
</template>

<script>
import GuidedValidationMixin from '@/mixins/guided-validation.js';

export default {
    name: 'StepValidation',

    mixins: [GuidedValidationMixin],

    props: {
        /**
         * Array of objects with 'text' and 'help_text' (optional) properties.
         */
        reasons: {
            type: Array,
            required: true,
            default: () => []
        },
        /**
         * Header text to display above the validation list.
         */
        header_text: {
            type: String,
            required: false,
            default: 'To continue, please fix the following:'
        },
        subheader_text: {
            type: String,
            required: false,
            default: null,
        },
        alert_color: {
            type: String,
            required: false,
            default: 'error'
        },
        icon_color: {
            type: String,
            required: false,
            default: 'error'
        },
        list_text_class: {
            type: String,
            required: false,
            default: 'primary--text'
        },
        action_button_color: {
            type: String,
            required: false,
            default: 'primary'
        },
    },

    methods: {
        showHelpAlert(item) {
            this.$rc.alert(
                'Unable to Proceed',
                item.help_text,
            );
        },

        onFixItem(item) {
            if (item.target) {
                this.mixinGuideToFix({ location: { target: item.target } });
            }
        },
    }
};
</script>

<style lang="scss" scoped>
:deep(.v-list-item) {
    min-height: unset !important;
}
</style>
